/**
 * MIT License
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Signed-in (non-admin) account home. The Fitbit-connect and opt-out controls that used to be here
 * were removed with the Fitbit Web API: participants now connect through their study link
 * (Google Health), and withdrawals are handled by the research team.
 */
import { Container, Paper, Typography } from '@mui/material';
import { useAuthContext } from '../auth/AuthContext';

const Dashboard = () => {
  const { userJamasp } = useAuthContext();

  return (
    <Container maxWidth="md" sx={{ mt: 1 }} align="center">
      <Typography variant="h5" gutterBottom>Your account</Typography>
      <Paper elevation={3} sx={{ m: 3, p: 3 }}>
        <Typography variant="body1" gutterBottom>
          You are signed in{userJamasp?.email ? ` as ${userJamasp.email}` : ''}.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Study participants join Jamasp through the link in their study. If you are a researcher and
          need access to a project, contact the Jamasp team. To withdraw from a study, contact the
          researchers through the study platform.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Dashboard;
